import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getManagedReturnsSettings = unaryRpc({
  name: "getManagedReturnsSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    billing: processingBillingConfigSchema,
    returnProcessingLevel: z.enum(["verification", "grading"]),
  }),
});
